import { render } from "./MainCardHeader.vue?vue&type=template&id=b0a925f6"
import script from "./MainCardHeader.vue?vue&type=script&lang=js"
export * from "./MainCardHeader.vue?vue&type=script&lang=js"

import "./MainCardHeader.vue?vue&type=style&index=0&id=b0a925f6&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__